import type { Alert } from '../rules/engine';

/* Alert cards — §7.1. Critical first; the engine has already sorted them.
   Every headline and body is plain English (§4.2). */
export function Alerts({ alerts, onOpen }: { alerts: Alert[]; onOpen: (ticker: string) => void }) {
  if (alerts.length === 0) {
    return (
      <div className="card card-pad">
        <div style={{ fontSize: 13 }}>Nothing is outside your limits right now.</div>
        <div className="dim" style={{ fontSize: 12, marginTop: 4 }}>
          Every position sits inside its ceiling and no review date has passed.
        </div>
      </div>
    );
  }

  return (
    <div className="hscroll" data-snap="center">
      {alerts.map((a) => {
        const Tag = a.positionId ? 'button' : 'div';
        return (
          <Tag
            key={a.id}
            className="alert-card"
            data-sev={a.severity}
            {...(a.positionId ? { onClick: () => onOpen(a.positionId!) } : {})}
          >
            <div className="alert-kind">
              <span aria-hidden="true">{a.severity === 'critical' ? '◆' : '▲'}</span>
              {a.severity === 'critical' ? 'BREACH' : 'WATCH'}
            </div>
            <div className="alert-headline">{a.headline}</div>
            <div className="alert-body">{a.body}</div>
          </Tag>
        );
      })}
    </div>
  );
}
